import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBadge } from 'noddi-ui-web';
import { commonTexts, formatDiscountPercent, hasDiscountPercent, type PriceListContextBannerTexts } from 'noddi-util';

type Props = {
  priceListName: string;
  discountPercent?: number | null;
  translations?: PriceListContextBannerTexts;
};

/**
 * The customer agreement their prices come from. Stated as a fact, not a success message —
 * nothing just happened, and a green banner made the agreement compete with the step's choices.
 */
export const PriceListContextBanner = ({ priceListName, discountPercent, translations }: Props) => {
  const texts = translations ?? commonTexts.priceListContextBanner;
  const percentText = hasDiscountPercent(discountPercent) ? formatDiscountPercent(discountPercent) : null;

  return (
    <div className='flex items-center gap-4 rounded-xl border border-border bg-card p-4'>
      <span className='flex size-9 shrink-0 items-center justify-center rounded-lg bg-muted text-foreground'>
        <NoddiIcon name='ShieldCheck' size='small' />
      </span>
      <div className='flex flex-col gap-1'>
        <div className='flex flex-wrap items-center gap-2'>
          <p className='font-medium'>{priceListName}</p>
          <NoddiBadge variant='success' withCircle>
            {texts.activeLabel}
          </NoddiBadge>
        </div>
        <p className='text-sm text-muted-foreground'>
          {percentText != null ? texts.withPercent(percentText) : texts.agreementOnly}
        </p>
      </div>
    </div>
  );
};
